var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.elephants),function(peer_info,id){return _c('div',{key:id},[_c('ElephantFriend',{attrs:{"hue":peer_info.hue,"currentX":peer_info.currentX,"targetX":peer_info.targetX}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }